/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   Homepage constants
 */

export const RECEIVE_LISTABLES = '@@nzr/Homepage/RECEIVE_LISTABLES'
export const RECEIVE_NEW_LISTABLES = '@@nzr/Homepage/RECEIVE_NEW_LISTABLES'
export const RECEIVE_PET_LISTABLES = '@@nzr/Homepage/RECEIVE_PET_LISTABLES'
export const RECEIVE_LUXURY_LISTABLES = '@@nzr/Homepage/RECEIVE_LUXURY_LISTABLES'
export const RECEIVE_UTILITIES_INCLUDED_LISTABLES =
  '@@nzr/Homepage/RECEIVE_UTILITIES_INCLUDED_LISTABLES'

export const SET_IS_LISTABLES_LOADING = '@@nzr/Homepage/SET_IS_LISTABLES_LOADING'
export const SET_IS_SPOTLIGHT_LISTABLES_LOADING =
  '@@nzr/Homepage/SET_IS_SPOTLIGHT_LISTABLES_LOADING'

export const FIXED_NAVBAR = '@@nzr/Homepage/FIXED_NAVBAR'

export const LISTINGS_TAB = '@@nzr/Homepage/LISTINGS_TAB'

export const RECEIVE_ADDRESS_LINKS = '@@nzr/Homepage/RECEIVE_ADDRESS_LINKS'
export const RECEIVE_BUILDING_LINKS = '@@nzr/Homepage/RECEIVE_BUILDING_LINKS'

export const RECEIVE_SPOTLIGHT_LISTABLES = '@@nzr/Homepage/RECEIVE_SPOTLIGHT_LISTABLES'
